<template>
    <section>
        <div class="module-content">
            <div class="view-selector-container">
                <button class="btn form-control view-selector" @click="view = 'events'">
                    <input type="radio" class="form-control" name="view" v-model="view" value="events"/>
                    Eventos
                </button>
                <button class="btn form-control view-selector" @click="view = 'entries'">
                    <input type="radio" class="form-control" name="view" v-model="view" value="entries"/>
                    Participações
                </button>
            </div>
            <div class="components-container">
                <EventsList v-show="view === 'events'" :eventsList="eventsList" @refresh-events="getEvents"/>
                <EntriesList v-show="view === 'entries'" :eventsEntriesList="eventsEntriesList"/>
            </div>
        </div>
    </section>
</template>

<script>
    import EventsList from './components/EventsList.vue';
    import EntriesList from './components/EntriesList.vue';
    export default {
        components: {EventsList, EntriesList},
        data() {
            return {
                view: 'events',
                eventsList: [],
                eventsEntriesList: []
            }
        },
        mounted(){
            this.getEvents();
            this.getEventsEntries();
        },
        methods: {
            getEvents(){
                axios.get('events/listEvents').then(({data}) => {
                    this.eventsList = data
                })
            },
            getEventsEntries(){
                axios.get('events/listEventsEntries').then(({data}) => {
                    this.eventsEntriesList = data
                })
            }
        }
    }
</script>

<style lang="scss" scoped>
.module-content {
    display: flex;
    flex-direction: column;
    gap: 10px;
    margin: 10px;
}
.view-selector-container {
    width: 100%;
    display: flex;
    gap: 10px;
    justify-content: center;
}

.view-selector {
    width: fit-content;
    display: flex;
    border: 1px solid lightgray;
    border-radius: 5px !important;
    box-shadow: 1px 1px 1px lightgray;
    align-items: center;
    gap: 5px;
    font-size: medium;
    font-weight: 600;
}
</style>